"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tab = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _metrics = require("../../_helpers/metrics");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Tabs.css");

var _styles = {
  "tabs": "Tabs__tabs___2O2xt",
  "tabs-titles": "Tabs__tabs-titles___37lC4",
  "tab-title": "Tabs__tab-title___UwzHq",
  "selected": "Tabs__selected___2M1EI"
};

const styles = _bind.default.bind(_styles);

const Tab = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  children
}) => {
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: className
  }, children);
});
exports.Tab = Tab;
const Tabs = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  selectedTab,
  onTabChange,
  children
}) => {
  const composed_classname = (0, _bind.default)(styles('tabs'), className);
  const [realSelectedTab, setRealSelectedTab] = (0, _react.useState)(selectedTab || 0);
  (0, _react.useEffect)(() => {
    if (typeof selectedTab === 'number') {
      setRealSelectedTab(selectedTab);
    }
  }, [selectedTab]);

  const renderTitle = (title, index) => {
    return _react.default.createElement("div", {
      key: `tab-title-${index}`,
      "data-testid": dataTestId && `${dataTestId}-tab-title-${index}`,
      className: styles('tab-title', {
        selected: realSelectedTab === index
      }),
      onClick: () => {
        if (dataTestId) {
          (0, _metrics.trackAction)(`click on ${dataTestId}-tab-title-${index}`);
        }

        setRealSelectedTab(index);
        onTabChange && onTabChange(index, title);
      }
    }, _react.default.createElement(_.Text, {
      size: 15,
      variant: realSelectedTab === index ? 'medium' : 'regular'
    }, title));
  };

  const renderTab = (child, index) => {
    return _react.default.createElement("div", {
      key: `tab-content-${index}`,
      "data-testid": dataTestId && `${dataTestId}-tab-${index}`,
      style: {
        display: realSelectedTab === index ? 'block' : 'none'
      }
    }, child);
  };

  const tabs = _react.default.Children.toArray(children).filter(child => {
    if (_react.default.isValidElement(child) && child.type === Tab) {
      return true;
    }

    throw new Error(`Tabs only supports the 'Tab' component`);
  });

  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname
  }, _react.default.createElement("div", {
    className: styles('tabs-titles')
  }, tabs.map((child, index) => renderTitle(child.props.tabTitle, index))), _react.default.createElement("div", {
    className: styles('tabs-content-wrapper')
  }, tabs.map(renderTab)));
});
var _default = Tabs;
exports.default = _default;